import { Component, inject } from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';
import { JsonObjectTreeComponent, ModalBase } from '@softline/ui-core';
import { Store } from '@softline/core';

@Component({
    selector: 'soft-store',
    imports: [JsonObjectTreeComponent],
    templateUrl: './store.component.html',
    styleUrl: './store.component.css'
})
export class StoreComponent extends ModalBase<any>{
  store = inject(Store);
  state = toSignal((this.store as any).state);
}
